// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchBills } from '../../../../hooks/useFetchBills';
import { BILLS_STATUSES } from '../../../../consts';
import { BILLS_TABLE_COLUMNS } from '../../components/BillsTable/consts';
import { BillsTable } from '../../components/BillsTable';
import { BILLS_TABLE_NAMES_TITLES } from '../../consts';
import { getBillById, mapBillsToBillsTableRow } from '../../utils';
import { useStore } from '../../../../../../store';
import { scrollWebappToTop } from '../../../../../Invoices/InvoiceHub/utils';
import { AVAILABLE_BILL_MODALS } from '../../components/BillsModalsHub/consts';
import { getUrlParamValueByKey } from '../../../../../../services/getUrlParamValueByKey';

export const UnpaidBills = () => {
  const unpaidBills = useStore(state => state.unpaidBills);
  const setUnpaidBills = useStore(state => state.setUnpaidBills);
  const pageNumber = useStore(state => state.unpaidBillsPageNumber);
  const setBillError = useStore(state => state.setBillError);
  const setActiveBillModal = useStore(state => state.setActiveBillModal);
  const setSearchParams = useStore(state => state.setSearchParams);
  const searchParams = useStore(state => state.searchParams);
  const setSelectedBillId = useStore(state => state.setSelectedBill);
  const setShowBillDetailsModal = useStore(state => state.setShowBillDetailsModal);
  const [hasMoreToFetch, setHasMoreToFetch] = useState<boolean>(true);
  const totalUnPaidBills = useStore(state => state.totalUnPaidBills);
  const setTotalUnPaidBills = useStore(state => state.setTotalUnPaidBills);
  const { t } = useTranslation();
  const { refetch: fetchBills, isFetching } = useFetchBills({
    status: BILLS_STATUSES.PENDING,
    pageNumber,
    sortBy: 'DUE_DATE',
    sortDirection: 'ASC',
    onSuccess: async (data: any) => {
      if (data?.results?.length === 0) {
        setHasMoreToFetch(false);
      } else {
        setUnpaidBills(data?.results, pageNumber > 0);
        setTotalUnPaidBills(data?.totalResults);
      }
    },
    onError: (e: any) => {
      setBillError(e);
      setActiveBillModal(AVAILABLE_BILL_MODALS.ERROR);
    },
  });
  useEffect(() => {
    setTimeout(() => {
      scrollWebappToTop();
    }, 0);
  }, []);

  useEffect(() => {
    if (hasMoreToFetch) {
      fetchBills();
    }
  }, [pageNumber]);
  useEffect(() => {
    if (unpaidBills.length > 0) {
      const billExternalId = getUrlParamValueByKey('id', searchParams) || '';
      if (billExternalId && getBillById(unpaidBills, billExternalId)) {
        setSelectedBillId(billExternalId);
        setShowBillDetailsModal(true);
        setSearchParams('');
      }
    }
  }, [unpaidBills]);
  const unpaidBillsRows = useMemo(() => mapBillsToBillsTableRow(unpaidBills), [unpaidBills]);
  return (
    <BillsTable
      title={`${t(BILLS_TABLE_NAMES_TITLES.UNPAID)} (${totalUnPaidBills})`}
      testId='BillsHub__unpaid-bills-table'
      columns={BILLS_TABLE_COLUMNS}
      tableName={t(BILLS_TABLE_NAMES_TITLES.UNPAID)}
      data={unpaidBillsRows}
      isLoading={isFetching && pageNumber === 0}
    />
  );
};
